import {useMutation, useQueryClient} from 'react-query'
import {BunkerRequest} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";
import useDashboardData from "../dashboard/useDashboardData";

const onMutateSuccess = (values: BunkerRequest) => {
    showNotification({
        title: 'Bunker request updated',
        icon: <Check/>,
        message: `Bunker request has been updated!`,
    })
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while updating the bunker request. ${error}`,
        color: 'red'
    })
}

export default function useMutateBunkerRequestData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    const {refetch} = useDashboardData();

    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload bunkerRequest data
            queryClient.invalidateQueries(['bunkerRequests']);

            // Reload dashboard data. TODO via queryClient?
            refetch();

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
